module.exports = __webpack_public_path__ + "img/girl-in-glass.9fa96992.webp";